module.exports = __webpack_public_path__ + "media/images/recruit/environments/ph_03-0dd6590c59810c19e2025fa642cde032.jpg";